import layouter from './layouter';

export default {
    __init__ : ['layouter'],
    layouter: ['type', layouter],
};